import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link, useParams } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  Icon,
  Typography
} from '@material-ui/core';
import { getQuoteCustomersCountByMarketingSegmentsApi } from 'api';
import { setQuoteMarketingSegmentData } from 'redux/actions/quote';
import { useStyles } from '../styles';
import SearchPatient from '../QuotePatient/SearchPatient';


const QuoteGroupInfo = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const params = useParams<{ [id: string]: string }>();
  const { userStoreData: {storeCode} } = useSelector((state: IReduxState) => state.user);
  const { currentMarketingSegment } = useSelector((state: IReduxState) => state.quote);
  const { options } = useSelector((state: IReduxState) => state.eavAttributes);

  const [searchPatientModalOpen, setSearchPatientModalOpen] = useState(false);
  const isCustomer3 = storeCode === 'customer3';

  useEffect(() => {
    getQuoteCustomersCountByMarketingSegmentsApi({
      dispatch,
      sortDirection: 'desc',
      sortField: 'created_at',
      pageSize: 10,
      currentPage: 1,
      searchConditions: [],
      field: 'marketing_segments',
      conditionType: 'like',
      marketingSegments: [{value: params?.id}]
    });
  }, []);

  useEffect(() => {
    const updatedMarketingSegment = options?.find((group) => group?.value === currentMarketingSegment?.value);
    dispatch(setQuoteMarketingSegmentData(updatedMarketingSegment));
  }, [options]);

  return (
    <Card className="px-4 pt-4 pb-6 root-card">
      <Box display="flex" justifyContent="space-between" alignItems="flex-start" className="mb-2">
        <Typography variant="h6" className={classes.patientTitle}>{`${isCustomer3 ? 'Customer' : 'Patient'}`} Marketing Segment</Typography>
        <Button
          component={Link}
          to="#"
          onClick={() => setSearchPatientModalOpen(true)}
          color="primary"
          size="small"
          className={classes.patientName}
          startIcon={<Icon>account_circle</Icon>}
        >
          {`Change ${isCustomer3 ? 'customer' : 'patient'}`}
        </Button>
      </Box>
      <Divider />
      <Grid className={`${classes.bgDeepBlue} px-6 py-4 mt-4`}>
        <Box display="flex" alignItems="center" mb={2}>
          <Typography variant="subtitle1" className={classes.patientName}>
            {currentMarketingSegment?.label}
          </Typography>
          <Box flexGrow={1} textAlign="right">
            <Icon
              className="cursor-pointer"
              onClick={() => history.push({pathname: '/quoting/'})}
            >
              close
            </Icon>
          </Box>
        </Box>
        <Divider />
        <Box display="flex" alignItems="center" mt={2}>
          <Typography variant="body1">
            {currentMarketingSegment?.total_count} {currentMarketingSegment?.total_count === 1 ? 'patient' : 'patients'}
          </Typography>
        </Box>
      </Grid>
      <SearchPatient open={searchPatientModalOpen} onClose={() => setSearchPatientModalOpen(false)} />
    </Card>
  );
};

export default QuoteGroupInfo;

